module.exports = __webpack_public_path__ + "media/images/fake/001-d50cee27e72516871a796da4879cbb25.jpg";